import { PayloadAction } from '@reduxjs/toolkit'
import { ReduxAppState } from '../types'

export const setNoteDetails = (
  state: ReduxAppState,
  action: PayloadAction<{ [note_id: string]: { template_id: string | null; isEmpty: boolean; noteBody: string } }>
) => {
  state.home.notes.noteDetails = action.payload
}
